export default {
  // Navigation & Layout
  app_name: 'ShareK',
  app_subtitle: 'شارك',
  nav_home: 'Home',
  nav_resources: 'Resources',
  nav_dashboard: 'Dashboard',
  nav_my_resources: 'My Resources',
  nav_peer_review: 'Peer Reviewing',
  nav_messages: 'Messages',
  nav_comments: 'Comments',
  nav_profile: 'My Profile',
  nav_settings: 'Settings',
  nav_admin_settings: 'Admin Settings',
  nav_login: 'Login',
  nav_logout: 'Logout',
  nav_add_resource: 'Add Resource',
  nav_about: 'About',
  nav_contact: 'Contact Us',

  // Actions communes
  save: 'Save',
  cancel: 'Cancel',
  delete: 'Delete',
  edit: 'Edit',
  create: 'Create',
  submit: 'Submit',
  send: 'Send',
  search: 'Search',
  filter: 'Filter',
  load_more: 'Load more',
  loading: 'Loading...',
  no_results: 'No results',
  back: 'Back',
  next: 'Next',
  close: 'Close',
  confirm: 'Confirm',
  yes: 'Yes',
  no: 'No',

  // États
  status_draft: 'Draft',
  status_under_review: 'Under Review',
  status_needs_revision: 'Needs Revision',
  status_peer_reviewed: 'Peer Reviewed',
  status_published: 'Published',
  status_not_evaluated: 'Not Evaluated',
  status_pending_reviewers: 'Waiting for Reviewers',

  // Types de ressources
  type_course: 'Course',
  type_worksheet: 'Worksheet',
  type_evaluation: 'Assessment',
  type_practical: 'Practical',
  type_simulation: 'Simulation',
  type_slides: 'Slides',

  // Types de commentaires
  comment_pedagogical: 'Pedagogical',
  comment_scientific: 'Scientific',
  comment_technical: 'Technical',
  comment_general: 'General',

  // Dashboard
  dashboard_greeting: 'Hello, {{name}}!',
  dashboard_subtitle: 'Here is what requires your attention today.',
  dashboard_stats_resources: 'Resources',
  dashboard_stats_validated: 'Validated',
  dashboard_stats_reviews: 'Active Reviews',
  dashboard_stats_comments: 'Comments',
  dashboard_section_author: 'What I am working on',
  dashboard_section_reviewer: 'My reviewer missions',
  dashboard_section_community: 'Community messages',
  dashboard_empty_author: 'You have not shared any resource yet.',
  dashboard_empty_reviewer: 'No reviewer missions in progress.',
  dashboard_empty_comments: 'No new comments or mentions.',

  // Settings
  settings_title: 'Settings',
  settings_subtitle: 'Manage your personal information, notifications and display preferences',
  settings_tab_account: 'Account',
  settings_tab_notifications: 'Notifications',
  settings_tab_display: 'Display',
  settings_tab_security: 'Security',
  settings_account_title: 'Account Information',
  settings_account_subtitle: 'Update your personal information',
  settings_name: 'Full Name',
  settings_name_placeholder: 'Your name',
  settings_email: 'Email',
  settings_email_locked: 'Email cannot be changed',
  settings_institution: 'Institution',
  settings_institution_placeholder: 'High school or middle school',
  settings_city: 'City',
  settings_city_placeholder: 'Ex: Rabat, Casablanca...',
  settings_specialty: 'Specialty',
  settings_level: 'Teaching Level',
  settings_level_select: 'Select...',
  settings_level_college: 'Middle School',
  settings_level_tcs: 'Common Scientific Core',
  settings_level_bac: 'High School Sciences',
  settings_level_all: 'All Levels',
  settings_bio: 'Biography',
  settings_bio_placeholder: 'Describe your background, pedagogical interests...',
  settings_bio_count: '{{count}}/500',
  settings_notifications_title: 'Notification Preferences',
  settings_notifications_subtitle: 'Choose when and how to be notified',
  settings_email_notifications: 'Email Notifications',
  settings_email_notifications_desc: 'Receive emails for important events',
  settings_push_notifications: 'Push Notifications',
  settings_push_notifications_desc: 'Real-time alerts within the application',
  settings_event_new_comment: 'New Comment',
  settings_event_new_comment_desc: 'When someone comments on your resource',
  settings_event_new_review: 'New Reviewer',
  settings_event_new_review_desc: 'When a teacher agrees to review your resource',
  settings_event_recommendation: 'Recommendation Submitted',
  settings_event_recommendation_desc: 'When a reviewer uploads their recommendation file',
  settings_display_title: 'Display Preferences',
  settings_display_subtitle: 'Customize the appearance of the application',
  settings_language: 'Language',
  settings_language_fr: 'Français',
  settings_language_ar: 'العربية',
  settings_theme: 'Theme',
  settings_theme_light: 'Light',
  settings_theme_dark: 'Dark',
  settings_theme_system: 'System',
  settings_security_title: 'Account Security',
  settings_security_subtitle: 'Manage your password and login',
  settings_change_password: 'Change Password',
  settings_change_password_desc: 'You will receive an email with a reset link',
  settings_reset_password_btn: 'Reset',
  settings_reset_email_sent: 'Reset email sent!',
  settings_logout: 'Logout',
  settings_logout_desc: 'You will need to log back in to access your account',
  settings_logout_btn: 'Log Out',
  settings_danger_zone: 'Danger Zone',
  settings_danger_subtitle: 'These actions are irreversible',
  settings_delete_account: 'Delete My Account',
  settings_delete_account_desc: 'All your resources, comments and data will be permanently deleted',
  settings_delete_account_confirm: 'Are you sure you want to delete your account? This action is irreversible.',
  settings_delete_account_btn: 'Delete',
  settings_saved: 'Changes saved',
  settings_saving: 'Saving...',
  settings_current_password: 'Current Password',
  settings_new_password: 'New Password',
  settings_confirm_password: 'Confirm Password',
  settings_password_updated: 'Password updated successfully',
  settings_password_error: 'Error updating password',
  settings_password_mismatch: 'Passwords do not match',
  settings_password_too_short: 'Password must be at least 6 characters',
  settings_update_password_btn: 'Update Password',

  // Messages / Chat
  msg_online: 'Online',
  msg_offline: 'Offline',
  msg_seen: 'Seen',
  msg_typing: 'typing...',
  msg_no_conversations: 'No conversations',
  msg_start_chat: 'Start chatting with an author from their profile or a resource.',
  msg_placeholder: 'Write a message...',
  msg_send_hint: 'Enter to send · Shift+Enter for new line · Max 3 files (5MB each)',
  msg_attach_image: 'Image',
  msg_attach_pdf: 'PDF',
  msg_attachment_max: 'Maximum 3 files reached',

  // Peer Review
  pr_join: 'Join as Reviewer',
  pr_status_reading: 'Reading',
  pr_status_accepted: 'Accepted',
  pr_status_recommendation: 'Recommendation',
  pr_anonymous: 'Anonymous',
  pr_reviewer: 'Reviewer',

  // Home / Landing
  home_hero_title: 'Share your knowledge,',
  home_hero_subtitle: 'enrich education',
  home_hero_desc: 'ShareK is a collaborative space where Life and Earth Sciences teachers share, evaluate, and improve educational resources together.',
  home_search_placeholder: 'Search a resource by title, topic, or keyword...',
  home_stats_resources: 'Resources Shared',
  home_stats_teachers: 'Active Teachers',
  home_stats_validated: 'Validated Resources',
  home_stats_reviews: 'Peer Reviews Done',
  home_about_share: 'Share',
  home_about_share_desc: 'Make your courses, worksheets, assessments, and practical activities available to the community.',
  home_about_evaluate: 'Evaluate',
  home_about_evaluate_desc: 'Receive constructive feedback from peers through peer reviewing to enrich your resources.',
  home_about_validate: 'Validate',
  home_about_validate_desc: 'Access quality content validated by the community and ready to use in class.',
  home_resources_title: 'Shared Resources',
  home_resources_subtitle: 'Discover courses, worksheets, assessments and activities from the community',
  home_teachers_title: 'Active Teachers',
  home_teachers_subtitle: 'Contributors enriching the platform',
  home_contact_title: 'Contact Us',
  home_contact_desc: 'A question, a suggestion, or want to join the adventure?',
  home_contact_email: 'contact@sharek.ma',
  home_contact_location: 'Morocco',

  // Login / Signup
  login_title: 'Login',
  login_email: 'Email',
  login_password: 'Password',
  login_btn: 'Log In',
  login_forgot_password: 'Forgot password?',
  login_no_account: 'No account yet?',
  login_signup_link: 'Sign Up',
  signup_title: 'Sign Up',
  signup_name: 'Full Name',
  signup_email: 'Email',
  signup_password: 'Password',
  signup_btn: 'Sign Up',
  signup_has_account: 'Already have an account?',
  signup_login_link: 'Log In',
  auth_error_invalid: 'Invalid email or password',
  auth_error_generic: 'An error occurred. Please try again.',

  // Admin Settings
  admin_settings_title: 'Platform Settings',
  admin_settings_subtitle: 'Manage resource categories and global ShareK settings',
  admin_settings_tab_categories: 'Categories',
  admin_settings_tab_platform: 'Global Settings',
  admin_settings_categories_desc: 'Organize school levels, resource types, teaching units and specialties available on the platform.',
  admin_settings_platform_desc: 'Configure the platform name, upload limits, enabled features and public texts.',
  admin_settings_cat_type_level: 'School Levels',
  admin_settings_cat_type_type: 'Resource Types',
  admin_settings_cat_type_unit: 'Teaching Units',
  admin_settings_cat_type_specialty: 'Specialties',
  admin_settings_cat_name: 'Name',
  admin_settings_cat_slug: 'Slug',
  admin_settings_cat_active: 'Active',
  admin_settings_cat_order: 'Order',
  admin_settings_cat_add: 'Add Category',
  admin_settings_cat_edit: 'Edit',
  admin_settings_cat_delete: 'Delete',
  admin_settings_cat_delete_confirm: 'Delete this category? It will no longer appear in forms but existing resources will not be affected.',
  admin_settings_cat_save: 'Save Category',
  admin_settings_cat_cancel: 'Cancel',
  admin_settings_platform_name: 'Platform Name',
  admin_settings_platform_tagline: 'Tagline',
  admin_settings_platform_hero_title: 'Home Banner Title',
  admin_settings_platform_hero_subtitle: 'Home Banner Subtitle',
  admin_settings_platform_contact_email: 'Contact Email',
  admin_settings_platform_max_upload: 'Max Upload Size (MB)',
  admin_settings_platform_max_reviewers: 'Max Reviewers per Resource',
  admin_settings_platform_min_reviewers: 'Min Reviewers Required',
  admin_settings_platform_resources_per_page: 'Resources per Page',
  admin_settings_platform_comments_per_page: 'Comments per Page',
  admin_settings_platform_analytics_retention: 'Analytics Retention (days)',
  admin_settings_platform_default_language: 'Default Language',
  admin_settings_platform_enable_signups: 'Allow Signups',
  admin_settings_platform_enable_peer_review: 'Enable Peer Review',
  admin_settings_platform_enable_comments: 'Enable Comments',
  admin_settings_platform_enable_messages: 'Enable Messaging',
  admin_settings_platform_auto_assign_reviewers: 'Auto-assign Reviewers',
  admin_settings_platform_maintenance_mode: 'Maintenance Mode',
  admin_settings_saved: 'Settings saved',
  admin_settings_save: 'Save Settings',
  admin_settings_saving: 'Saving...',
  admin_settings_reset: 'Reset to Defaults',
  admin_settings_no_categories: 'No categories in this section',
  admin_settings_add_first_category: 'Add your first category',

  // Errors / Misc
  error_generic: 'An error occurred',
  error_not_found: 'Page not found',
  error_not_found_desc: 'The page you are looking for does not exist or has been moved.',
  error_back_home: 'Back to Home',
};